<template>
	<div>
		<el-form ref="pram" :model="pram" :rules="rules" label-width="110px" @submit.native.prevent>
			<el-form-item label="客户姓名" prop="name">
				<el-input v-model="pram.name" placeholder="请输入客户姓名" />
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input v-model="pram.phone" placeholder="请输入手机号" />
			</el-form-item>
			<el-form-item label="服务地址" prop="citys">
				<el-cascader
					v-model="pram.citys"
					:options="cityList"
					@change="cityChange"
					style="width: 100%"
					placeholder="请选择服务地址"></el-cascader>
			</el-form-item>
			<el-form-item label="详细地址" prop="address">
				<el-input v-model="pram.address" placeholder="请输入详细地址" />
			</el-form-item>
			<el-form-item label="备注" prop="comment">
				<el-input v-model="pram.comment" placeholder="请输入备注" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" :loading="loading" @click="handlerSubmit('pram')">
					{{ isCreate === 0 ? '确定' : '更新' }}
				</el-button>
				<el-button @click="close">取消</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	// import * as customerApi from '@/api/customer'
	import citys from '@/utils/city';
	export default {
		props: {
			isCreate: {
				type: Number,
				required: true,
			},
			sourceList: {
				type: Array,
				required: true,
			},
			editData: {
				type: Object,
				default: () => {
					return { rules: [] };
				},
			},
		},
		data() {
			return {
				loading: false,
				constants: this.$constants,
				pram: {
					sourceName: '',
				},
				cityList: citys,
				rules: {
					name: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ pattern: /^1[3|5|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change' },
					],
					sourceName: [{ required: true, message: '请输入来源名称', trigger: 'blur' }],
					citys: [
						{ required: true, message: '请选择服务地址', trigger: 'blur' },
						{ validator: this.validateCitys, trigger: 'blur' },
					],
				},
			};
		},
		mounted() {
			this.initEditData();
		},
		methods: {
			validateCitys(rule, value, callback) {
				if (Array.isArray(value) && value.some(str => str === '')) {
					callback(new Error('服务地址不能为空'));
				} else {
					callback();
				}
			},
			cityChange(val) {
				var areaAddress = '';
				this.cityList.map(item => {
					if (item.value === this.pram.citys[0]) {
						areaAddress += item.label;
						if (item.children && this.pram.citys.length > 1) {
							item.children.map(item2 => {
								if (item2.value === this.pram.citys[1]) {
									areaAddress += item2.label;
									if (item2.children && this.pram.citys.length > 2) {
										item2.children.map(item3 => {
											if (item3.value === this.pram.citys[2]) {
												areaAddress += item3.label;
											}
										});
									}
								}
							});
						}
					}
				});
				this.pram.areaAddress = areaAddress;
			},
			changeSource(id) {
				this.sourceList.forEach(item => {
					if (item.id === id && id != 151) {
						this.pram.sourceName = item.name;
					}
				});
			},
			close() {
				this.$emit('hideEditDialog');
			},
			initEditData() {
				if (this.isCreate !== 1) return;
				this.pram = this.editData;
				console.log(this.pram, 'this.pram');
			},
			handlerSubmit(form) {
				this.$refs[form].validate(valid => {
					if (!valid) return;
					this.pram.sourceId = 3;
					this.pram.areaCode = this.pram.citys.join(',');
					if (this.isCreate === 0) {
						this.loading = true;
						this.handlerSave();
					} else {
						this.loading = true;
						this.handlerEdit();
					}
				});
			},
			handlerSave() {
				// customerApi.addCustomer(this.pram).then(data => {
				//   this.$message.success('创建客户成功')
				//   this.$emit('hideEditDialog')
				//   this.loading = false
				// }).catch(err => {
				//   this.loading = false
				// })
			},
			handlerEdit() {
				// customerApi.updateCustomer(this.pram).then(data => {
				//   this.$message.success('更新客户成功')
				//   this.$emit('hideEditDialog')
				//   this.loading = false
				// }).catch(err => {
				//   this.loading = false
				// })
			},
		},
	};
</script>

<style scoped></style>
